import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/bootstrap.min.css';
import 'assets/styles/font_faces.css';
import 'assets/styles/animations.css';
import 'assets/styles/style.css';
import 'assets/styles/toastr.css';
import 'assets/styles/index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js